import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaChartGantt } from "react-icons/fa6";
import Productivity from "./index";

const productivityRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Productivity",
        basePath: "productivity",
        mainComponent: <Productivity/>,
        layout: "/console", 
        icon: <FaChartGantt className="icon-item" />,
        subTitle:"Productivity",
        level:5,
        moduleId: 0,
    })
]

export default productivityRoutes;